import { render, staticRenderFns } from "./c_divider.vue?vue&type=template&id=3d505198&scoped=true"
import script from "./c_divider.vue?vue&type=script&lang=js"
export * from "./c_divider.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3d505198",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/crmeb/admin/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('3d505198')) {
      api.createRecord('3d505198', component.options)
    } else {
      api.reload('3d505198', component.options)
    }
    module.hot.accept("./c_divider.vue?vue&type=template&id=3d505198&scoped=true", function () {
      api.rerender('3d505198', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/design/components/mobileConfigRight/c_divider.vue"
export default component.exports